export default __webpack_public_path__ + "static/media/company-select.b883ca40.png";